<template>
	<div class="clock" :class="{ 'hrsClass': hrsActive }">
		{{ timerCount }}
	</div>
</template>

<script>
export default {
	props: {
		clockType: { type: String, required: true, default: `up` },
		clockMinutes: { type: Number, required: true, default: 0 }
	},	
	data() {
		return {			
			secondsRemaining: 0,
			direction: this.clockType,
			intervalHandler: null,
			hrsActive: false
		};
	},
	computed: {
		timerCount() {
			// turn the seconds into mm:ss format
			let hrs = Math.floor(this.secondsRemaining / 3600);
			let min = Math.floor(this.secondsRemaining / 60);
			let sec = Math.floor(this.secondsRemaining - (min * 60));
			if(hrs == 0) {
				return `${min}:${String(sec).padStart(2, `0`)}`;
			} else {
				this.hrsActive = true;
				let min = Math.floor(this.secondsRemaining / 60) % 60;
				return `${hrs}:${String(min).padStart(2, `0`)}:${String(sec).padStart(2, `0`)}`;
			}
		},
	},
	mounted() {
		this.secondsRemaining = this.clockMinutes * 60;
		this.intervalHandler = setInterval(this.timeTick, 1000);
	},
	methods: {
		timeTick() {
			if (this.direction == `down`) {
				//subtract seconds remaining from clockMinutes
				this.secondsRemaining--;
			} else {
				this.secondsRemaining++;
			}
			// clock is down to zero so clear value
			if (this.secondsRemaining <= 0) {
				clearInterval(this.intervalHandler);
			}
		}
	}
};
</script>